module.exports = __webpack_public_path__ + "img/men.bb4b1e5b.jpeg";